import { useState } from "react";
import { tss } from "tss-react";
import { SketchPicker } from "react-color";
import { ColorBand } from ".";
import { hexToRgb, StorageUtils, uniqueArray } from "services/UtilsService";
import { defaultColors } from "constants/viewer";
import { Colorize, ArrowRight } from "@mui/icons-material";
import commonStyles from "styles/common";

const useStyles = tss.create({
    subSectionLabel: {
        marginTop: 15,
        marginBottom: 7,
        marginLeft: -5,
        fontFamily: "Arial",
        fontSize: 14,
        color: "#283C50",
        letterSpacing: 0,
        lineHeight: "16px",
    },
    Color: {
        marginTop: 10,
        marginLeft: 0,
        marginRight: 0,
        marginBottom: 10,
    },
    twoSided: {
        display: "inline-flex",
        alignItems: "center",
        position: "absolute",
        right: 10,
        marginTop: 5,
    },
    palette: {
        width: 270,
        height: 265,
        overflowY: "hidden",
        position: "relative",
    },
    picker: {
        width: "250px !important",
        boxShadow: "none !important",
        " & div > div > div > label ": {
            paddingTop: "8px !important",
        },
    },
});

var pickedColor = "";

type IProps = {
    selectedColor: string;
    doubleSided: boolean;
    onColorClick: (side: string, color: any) => void;
    onDoubleSided: (enabled: boolean) => void;
    side?: any;
    style?: any;
};

export default function ColorPalette(props: IProps) {
    const { classes: common } = commonStyles();
    const { classes } = useStyles();
    var { selectedColor, onColorClick, side, style } = props;
    const [showPalette, setShowPalette] = useState(false);
    const [userColors, setUserColors] = useState(StorageUtils.loadFromSessionStorage("userColors") || []);
    var currentColors: any = [...defaultColors];
    currentColors = userColors.concat(currentColors).splice(0, 21);

    const assignColor = (color: string) => {
        var rgb = { rgb: hexToRgb(color) };
        //console.log('color:', color, '|rgb:', rgb);
        onColorClick(side, rgb);
    };

    const openPalette = (evt: any) => {
        if (showPalette) {
            var colors: any = [...userColors];
            if (pickedColor !== "" && !colors.includes(pickedColor)) {
                colors.unshift(pickedColor);
                colors = uniqueArray(colors);
                StorageUtils.saveToSessionStorage("userColors", colors);
            }
            setUserColors(colors);
        }
        setShowPalette((prevVal) => !prevVal);
    };

    const handleColorChange = (newValue: any) => {
        pickedColor = newValue.hex.toUpperCase();
        //console.log('newValue.hex:', newValue.hex.toUpperCase());
        var rgb = { rgb: hexToRgb(newValue.hex.toUpperCase()) };
        onColorClick(side, rgb);
    };

    return (
        <div style={style}>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    height: 48,
                    width: 276,
                    position: "relative",
                }}
            >
                {currentColors.map((color: string, index: number) => (
                    <div
                        className={common.verticalMiddleCenter}
                        style={{
                            width: 24,
                            height: 24,
                            cursor: "pointer",
                            border: selectedColor === color ? "solid 1px #4F4F4F" : "",
                        }}
                        key={"color-" + side + "-" + index}
                        onClick={(evt: any) => assignColor(color)}
                    >
                        <ColorBand width={16} background={color} />
                    </div>
                ))}
                <div onClick={openPalette} style={{ cursor: "pointer" }}>
                    <Colorize />
                    <ArrowRight
                        style={{
                            width: 16,
                            height: 16,
                            position: "absolute",
                            right: 9,
                            top: 35,
                            transform: "rotate(45deg)",
                        }}
                    />
                </div>
            </div>
            <div
                className={classes.palette}
                style={{
                    position: "relative",
                    display: showPalette ? "inline-flex" : "none",
                }}
            >
                <SketchPicker color={selectedColor} className={classes.picker} onChangeComplete={handleColorChange} />
            </div>
        </div>
    );
}
